import { SafePromise } from '@benzinga/safe-await';
import { IncludeHeader, RestfulClient, Session } from '@benzinga/session';
import { RestfulStory, NewsBZQLRequestQuery } from '../entities';
import { AdvancedNewsEnvironment } from '../environment';

// cloudflared access login https://content-server.prod.api.benzinga.dev
// cloudflared access token -app=https://content-server.prod.api.benzinga.dev
// cloudflared access tcp --hostname content-server.prod.api.benzinga.dev --url localhost:9000

export class NewsInternalContentRestful extends RestfulClient {
  constructor(session: Session, includeHeaders?: IncludeHeader) {
    super(session.getEnvironment(AdvancedNewsEnvironment).internalContentUrl, session, includeHeaders);
  }

  public isCloudflareApi = () => {
    return this.hostname.host.match('cloudflared-api.benzinga.com') ? true : false;
  };

  public getStories = async (query: Partial<NewsBZQLRequestQuery>): SafePromise<{ data: RestfulStory[] }> => {
    // console.log(JSON.stringify(query));
    const url = this.URL(`/api/v3/internal/news/advanced`);
    return this.post<{ data: RestfulStory[] }, Partial<NewsBZQLRequestQuery>>(url, query, {
      allowsAnonymousAuth: true,
      headers: this.isCloudflareApi()
        ? {
            'CF-Access-Client-Id': this.session.getEnvironment(AdvancedNewsEnvironment)['CF-Access-Client-Id'],
            'CF-Access-Client-Secret': this.session.getEnvironment(AdvancedNewsEnvironment)['CF-Access-Client-Secret'],
          }
        : {},
      resilience: {
        delayMultiple: 200,
        delayOffset: 3000,
        isError: undefined,
        maxDelay: 60000,
        maxNumOfAttempts: 3,
        retryOnError: true,
      },
    });
  };
}
